import { GtmTrackingType } from '../constants';
import TrackingHelperInstance from './gtmTrackingHelper';

class GtmProductImpressionViewDelegator {
	constructor() {
		this.type = GtmTrackingType.PRODUCT_IMPRESSION_VIEW;
		this.dataMapper = [
			{
				defaultValue: TrackingHelperInstance.generateActionFieldString(),
				gtmKey: 'list',
			},
			{ dataName: 'data-product-title', gtmKey: 'name' },
			{ dataName: 'data-legacy-sku', gtmKey: 'id' },
			{ dataName: 'data-price-excl', gtmKey: 'price' },
			{ dataName: 'data-sku-category-name', gtmKey: 'category' },
			{ dataName: 'data-sku-item-category', gtmKey: 'item_category' },
			{ dataName: 'data-sku-item-category2', gtmKey: 'item_category2' },
			{ dataName: 'data-sku-item-category3', gtmKey: 'item_category3' },
			{ dataName: 'data-stock-status-ga', gtmKey: 'dimension27' },
			{ defaultValue: 1, gtmKey: 'position' },
		];
	}

	getTrackingData() {
		const selector = '[data-gtm-tracking-type="gtm_product_view"]';
		const products = Array.from(document.querySelectorAll(selector));

		if (products.length) {
			return {
				event: 'productView',
				ecommerce: {
					impressions: products.map(product =>
						TrackingHelperInstance.getRequiredDataAsObject(
							product,
							this.dataMapper,
						),
					),
				},
			};
		}
	}
}

const GtmProductImpressionViewDelegatorInstance =
	new GtmProductImpressionViewDelegator();
export default GtmProductImpressionViewDelegatorInstance;

// for test purpose only
export const GtmProductImpressionViewDelegatorClass =
	GtmProductImpressionViewDelegator;
